export default {
  banOperate: true,
  props: [
    {
      attr: 'createTime',
      name: '导入完成时间',
      slot: 'createTime'
    },
    {
      attr: 'result',
      name: '导入结果',
      slot: 'result'
    },
    {
      attr: 'download',
      name: '下载错误报告',
      slot: 'download'
    }
  ]
}
